import { render } from "./TableInfoCliente.vue?vue&type=template&id=49f6d5fc&ts=true"
import script from "./TableInfoCliente.vue?vue&type=script&lang=ts"
export * from "./TableInfoCliente.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/AreaClienti_SELENIA/AreaClienti_SELENIA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__